import { render, staticRenderFns } from "./map.vue?vue&type=template&id=fcaefa9e"
import script from "./map.vue?vue&type=script&lang=js"
export * from "./map.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PrimaryButton: require('/vercel/path0/components/ui/primaryButton.vue').default,Staff: require('/vercel/path0/components/staff.vue').default,ClinicSummary: require('/vercel/path0/components/clinicSummary.vue').default})
